<template>
  <div class="pending-header-container">
    <div class="fiduciary-and-fiduciary-client">
      <selected-fiduciary></selected-fiduciary>
      <div class="vertical-line"></div>
      <client-selector
        :selectedText="selectedClientName"
        :canSelect="localPolicyOptions.options['select-client']"
        @onSelect="toggleClientList"
      />
    </div>
    <transition name="scale">
      <clientList
        v-show="clientListVisible"
        :fiduciary="selectedFiduciary"
        :selectedClient="selectedClient"
        @closeClientList="toggleClientList"
        @updateClientFunds="updateClient"
      />
    </transition>
    <navigation-list :items="tabs.items" :selected="selectedTab" @selectedItem="selectTab" />
    <search-field :disabled="!localPolicyOptions.options.search" @onChange="changeSearchTerm" />
  </div>
</template>
<script>
import { get } from 'lodash';
import { mapState } from 'vuex';
import NavigationList from '@/components/atoms/NavigationList';
import ClientList from '@/components/atoms/ClientList';
import ClientSelector from '@/components/atoms/ClientSelector';
import SearchField from '@/components/atoms/SearchField';
import SelectedFiduciary from '@/components/atoms/SelectedFiduciary';
import { getPendingReplacementFlag } from '@/services/PendingReplacements';

export default {
  name: 'pending-header',
  components: {
    SelectedFiduciary,
    ClientList,
    ClientSelector,
    SearchField,
    NavigationList,
  },
  data() {
    return {
      tabs: {
        items: [
          {
            id: 'status-changes',
            text: 'Fund Changes',
          },
          {
            id: 'lineups',
            text: 'Lineup Changes',
          },
          {
            id: 'replacements-new',
            text: '3(21) Replacements',
          },
        ],
        selected: 'status-changes',
      },
    };
  },
  computed: {
    ...mapState({
      policies: (state) => state.user.policies,
      selectedFiduciary: (state) => state.user.fiduciary.id,
      selectedClient: (state) => state.pending.client.selected,
      selectedClientName: (state) => state.pending.client.name,
      clientListVisible: (state) => state.pending.client.listVisible,
      selectedTab: (state) => state.pending.tab,
    }),
    currentViewName() {
      return this.selectedClient > 0 ? 'one-client' : 'all-clients';
    },
    localPolicyOptions() {
      // Tabs are applied to both Views
      return get(this.policies, `pending.views.${this.currentViewName}.tabs.${this.selectedTab}`);
    },
  },
  created() {
    getPendingReplacementFlag().then((result) => {
      if (result?.data?.replacementFlag) {
        const newReplacementTab = {
          id: 'replacements',
          text: '3(21) Replacements Old',
        };
        this.tabs.items.push(newReplacementTab);
      }
    });
  },
  methods: {
    toggleClientList() {
      if (this.localPolicyOptions.options['select-client']) {
        this.$store.dispatch('setPendingClientListVisible', !this.clientListVisible);
      }
    },
    updateClient(client, clientName, clientCode) {
      this.$store.dispatch('setPendingClient', {
        listVisible: false,
        name: clientName,
        code: clientCode,
        selected: client,
      });
    },
    selectTab(selected) {
      this.tabs.selected = selected;
      this.$store.dispatch('setPendingTab', selected);
      this.$store.dispatch('setPendingItemsDisplayed', 0);
      this.$store.dispatch('setPendingSearchTerm', '');
    },
    changeSearchTerm(text) {
      this.$store.dispatch('setPendingSearchTerm', text);
    },
  },
};
</script>
<style lang="scss">
.pending-header-container {
  flex: 0 0 111px;
  position: relative;
  background-color: #12698d;
  color: $mds-color-white;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.1s ease-out;
  transform-origin: top left;
}
.scale-enter,
.scale-leave-to {
  transform: scaleY(0);
  opacity: 0;
}

.fiduciary-and-fiduciary-client {
  display: flex;
  flex-direction: row;
  line-height: 0;
}

.vertical-line {
  border-left: $mds-space-quarter-x solid $mds-background-color-white;
  margin: $mds-space-1-x 0 $mds-space-1-x 0;
}
</style>
